import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

/** Ported from gpp-website blocking popup logo for matching dimensions. */
export const PlanetSportBetCompliancePopupLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='115'
        height='24'
        viewBox='0 0 115 24'
        fill='none'
    >
        <path
            d='m3.799 10.853.137-.759.511-2.82h4.525l1.961-1.634.725-4.005L10.285 0H1.146l1.99 1.332-1.72 9.521h2.383ZM8.037 5.42H4.78l.649-3.564h3.258l.483.575-.423 2.415-.709.574Zm10.936 5.434.362-1.958h-5.264L15.67 0h-2.384l-1.96 10.853h7.648Zm3.57 0 1.117-2.4h4.208l.257 2.4h2.413L29.105 0H25.32l-5.445 10.853h2.67Zm5.13-4.27h-3.138l2.187-4.669h.452l.498 4.669Zm6.41 4.27 1.267-6.965h.513l2.776 6.965h2.307L42.907 0H40.6l-1.298 7.157L36.452 0h-2.716l-1.96 10.853h2.307Zm17.136 0 .347-1.958h-5.687l.483-2.725h5.174l.347-1.885h-5.174l.422-2.326h5.687L53.18 0h-8.085l-1.961 10.853h8.085Zm6.335 0 1.614-8.894h3.108L62.638 0h-8.613l-.362 1.959h3.122l-1.614 8.894h2.383Zm11.344 0 1.976-1.634.588-3.27-1.388-1.634H65.67l-.498-.59.21-1.192.71-.589h5.49L71.93 0h-6.773L63.18 1.635l-.528 2.945 1.372 1.65 4.42-.015.498.588-.271 1.518-.71.588h-5.686l-.347 1.944h6.969Zm5.883 0 .648-3.578h4.526l1.96-1.635.724-4.005L81.267 0h-6.909l-1.96 10.853h2.383Zm4.238-5.434h-3.258l.649-3.564h3.258l.483.575-.423 2.415-.709.574Zm11.22 5.434 1.976-1.634 1.373-7.584L92.2 0h-6.034L84.19 1.635l-1.358 7.584 1.373 1.634h6.034Zm-.95-1.855h-3.44l-.498-.59 1.086-5.978.71-.575h3.408l.498.575-1.07 5.979-.695.589Zm6.792 1.855.694-3.843h2.79l.905 3.843h2.384l-1.041-4.123 1.644-1.355.679-3.74L102.748 0h-7.09l-1.96 10.853h2.383Zm4.465-5.699h-3.44l.604-3.299h3.439l.483.575-.377 2.15-.709.574Zm8.492 5.7 1.614-8.895h3.108L114.122 0h-8.613l-.362 1.959h3.122l-1.614 8.894h2.383Z'
            fill='#fff'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M80.133 18.75H.326L.6 17.41h79.807l-.273 1.34Z'
            fill='#EC004F'
        />
        <path
            d='m89.974 24 1.945-1.638.553-3.07-.987-1.18.837-.797.42-2.346-1.541-1.845h-6.118L83.139 24h6.835Zm-.255-6.427H86.17l.486-2.718h3.533l.53.643-.236 1.345-.765.73Zm-.396 4.697H85.16l.595-3.213h4.163l.549.64-.35 1.933-.794.64ZM101.386 24l.303-1.682h-5.726l.56-3.173h5.241l.303-1.682h-5.225l.47-2.656h5.739l.303-1.683h-7.633L93.752 24h7.634Zm5.779 0 1.653-9.193h3.066l.315-1.683h-8.038l-.301 1.683h3.065L105.287 24h1.878Z'
            fill='#EC004F'
        />
    </SvgElement>
);
